type AuthErrorType =
  | {
      type: 'no-access';
    }
  | {
      type: 'unknown-error';
      error: unknown;
    };

export class AuthError extends Error {
  error: AuthErrorType;

  constructor(error: AuthErrorType) {
    super(error.type);
    this.error = error;
  }
}
